import React from 'react';

import Grid from '../Grid';

const Form: React.FC = ({ children }) => <Grid container>{children}</Grid>;

export default Form;
